import { gql } from '@apollo/client';

export const GET_TICKETS = gql`
  query GET_TICKETS($incidentId: ID!, $originatorId: ID!){
    getTickets(incidentId: $incidentId, originatorId: $originatorId) {
      id
      ticketNumber
      issuedTo {
        id
      }
    }
  }
`;

export const GET_ARRESTS = gql`
  query GET_ARRESTS($incidentId: ID!, $originatorId: ID!){
    getArrests(incidentId: $incidentId, originatorId: $originatorId) {
      id
      arrestee {
        id
      }
    }
  }
`;

export const GET_PERSON_INCIDENT_SPECIFICS = gql`
  query GET_PERSON_INCIDENT_SPECIFICS($incidentId: ID!, $originatorId: ID!){
    getIncident(incidentId: $incidentId, originatorId: $originatorId) {
      id
      incidentNumber
      personIncidentSpecifics {
        id
        sealed
        juvenile
        yoe
        person {
          id
          personalAttribute {
            id
            lastName
            firstName
          }
        }
      }
    }
  }
`;